// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// FILE SCOPING DATA SCHEMA
/////////////////////////////////////////

export const FileScopingDataSchema = z.object({
  clientSideTechnologies: z.string().array(),
  databases: z.string().array(),
  serverSideLanguage: z.string().nullable(),
})

export type FileScopingData = z.infer<typeof FileScopingDataSchema>

export default FileScopingDataSchema;
